import { Directive, ElementRef, Optional, Self, OnInit, OnDestroy } from '@angular/core';
import { InputComponent } from '../components/forms/input/input.component';

@Directive({
    selector: '[jhiOnlyNumber]'
})
export class OnlyNumbersDirective implements OnInit, OnDestroy {

    private regex: RegExp = new RegExp(/^[0-9]+$/g);
    private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'Delete', 'ArrowLeft', 'ArrowRight'];

    constructor(private el: ElementRef, @Self() @Optional() private input: InputComponent) {
    }


    ngOnInit(): void {
        this.el.nativeElement.addEventListener('keydown', this.onKeyDown.bind(this), true);
    }

    ngOnDestroy(): void {
        this.el.nativeElement.removeEventListener('keydown', this.onKeyDown);
    }

    onKeyDown(event: any) {
        if ((this.specialKeys.indexOf(event.key) !== -1) || ((event.getModifierState) && (event.getModifierState('Accel')))) {
            return;
        }
        // Do not use event.keycode this is deprecated.
        // See: https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode
        let current: string = this.el.nativeElement.value || (this.input || {value: ''}).value || '';
        // We need this because the current value on the DOM element
        // is not yet updated with the value from this event
        let next: string = current.concat(event.key);
        if (next && !String(next).match(this.regex)) {
            event.preventDefault();
        }

    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/directives/only-numbers.directive.ts